exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.van-cell[data-v-54a849d0]::after {\r\n  position: absolute;\r\n  box-sizing: border-box;\r\n  content: \" \";\r\n  pointer-events: none;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0.42667rem;\r\n  -webkit-transform: scaleY(0.5);\r\n  transform: scaleY(0.5);\n}\n.desion .van-cell__label[data-v-54a849d0] {\r\n  color: #f60 !important;\n}\n.desion .van-cell[data-v-54a849d0] {\r\n  padding: 0 0.42667rem 0.26667rem 0.42667rem !important;\n}\n.selectInfor[data-v-54a849d0]{\r\n    border-bottom: 0.6px solid #f2f3f5 !important;\n}\n.selectInfor .van-cell[data-v-54a849d0]:not(:last-child)::after{\r\n  border:0 !important;\n}\r\n", ""]);

// exports
